import {DATETIME} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

// Types
import {dateTime, apiDateTime} from '@drivesally/sally-fw/lib/type';

export default attribute({
  type: DATETIME,
  attribute: 'repo_start_date',
  display: dateTime,
  input: dateTime,
  api: apiDateTime,
  label: {
    default: 'Repo Start Date',
    short: 'Repo Start Date',
  },
});
